/**
 * Username validation and reserved words management
 */

const RESERVED_WORDS = [
  'login',
  'logout',
  'signup',
  'signin',
  'register',
  'editor',
  'dashboard',
  'settings',
  'admin',
  'api',
  'assets',
  'static',
  'public',
  'private',
  'auth',
  'user',
  'users',
  'profile',
  'profiles',
  'about',
  'contact',
  'help',
  'support',
  'terms',
  'privacy',
  'legal',
  'docs',
  'documentation',
  'faq',
  'blog',
  'news',
  'shop',
  'store',
  'checkout',
  'cart',
  'payment',
  'invoice',
  'billing',
  'account',
  'subscription',
  'premium',
  'pro',
  'business',
  'enterprise',
  'favicon.ico',
  'robots.txt',
  'sitemap.xml',
  'manifest.json',
  'service-worker.js',
  'sw.js',
] as const;

const USERNAME_REGEX = /^[a-z0-9_]{3,20}$/;

export function isValidUsername(username: string): boolean {
  return USERNAME_REGEX.test(username);
}

export function isReservedWord(username: string): boolean {
  const normalized = username.toLowerCase();
  return RESERVED_WORDS.some(word => word === normalized);
}

export function validateUsername(username: string): {
  valid: boolean;
  error?: string;
} {
  if (!username || username.length === 0) {
    return { valid: false, error: 'Username is required' };
  }

  if (!isValidUsername(username)) {
    return {
      valid: false,
      error: 'Username must be 3-20 characters, lowercase letters, numbers, and underscores only',
    };
  }

  if (isReservedWord(username)) {
    return {
      valid: false,
      error: 'This username is reserved and cannot be used',
    };
  }

  return { valid: true };
}

export function normalizeUsername(username: string): string {
  return username.toLowerCase().trim();
}

export { RESERVED_WORDS };
